export default __webpack_public_path__ + "static/media/ip.78108642.gif";